import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SpeedIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M14 8a1 1 0 011 1v3.434l2.015 1.209a1 1 0 01-1.03 1.714L13 13.567V9a1 1 0 011-1z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M12 2a1 1 0 100 2h1v1.062A7.99 7.99 0 007.755 8H5a1 1 0 000 2h1.582a7.977 7.977 0 00-.52 4H5a1 1 0 100 2h1.582A8.003 8.003 0 0022 13a8.001 8.001 0 00-7-7.938V4h1a1 1 0 100-2h-4zm8 11a6 6 0 11-12 0 6 6 0 0112 0zM2 11a1 1 0 100 2h2a1 1 0 100-2H2z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
SpeedIcon.isCarinaIcon = true;
export default SpeedIcon;
